import { defineStore } from "pinia";
import { computed,ref } from "vue";

export const useAuthStore = defineStore("auth", () => {

  const user = ref(null);
  const payload = ref(null);

  const hasPermission = (permission) => {
    return payload.value && payload.value.permissions.includes(permission);
  }

  const hasAnyPermission = (permissions) => {
    return permissions.some(permission => hasPermission(permission));
  }

  const isAuthenticated = computed(() => {
    return user.value !== null && hasAnyPermission(['is:admin', 'is:system']);
  })

  const isAdmin = computed(() => {
    return user.value !== null && hasPermission('is:admin');
  })

  const canManageUser = computed(() => {
    return user.value !== null && hasPermission('manage:user');
  })

  const canManageAdmin = computed(() => {
    return user.value !== null && hasPermission('manage:admin-user');
  })

  const canManageAuction = computed(() => {
    return user.value !== null && hasPermission('manage:auction');
  })

  const canManageAuctionOrCebis = computed(() => {
    return user.value !== null && hasAnyPermission(['manage:auction', 'cebis:crud']);
  })

  const canManagePlatform = computed(() => {
    return user.value !== null && hasPermission('manage:platform');
  })

  return { user, payload, hasPermission, hasAnyPermission, isAuthenticated, isAdmin, canManageUser, canManageAdmin, canManageAuction, canManageAuctionOrCebis, canManagePlatform};
});
